import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Spinner } from '../Spinner/index.js';

const LoadingStateContainer = styled.div `
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-grow: 1;
  margin: 16px 0;
  align-self: center;
`;
const StyledSpinner = styled(Spinner) `
  display: flex;
  align-self: center;
`;
const LoadingState = () => (jsx(LoadingStateContainer, { children: jsx(StyledSpinner, { size: "40px", primary: true }) }));

export { LoadingState };
